// src/App.js

import './App.css';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import Master from 'master/Master';
import Login from 'pages/login/Login';
import Signup from 'pages/sign_up/Signup';
import ResetPassword from 'pages/reset_password/ResetPassword';
import NewPassword from 'pages/new_password/NewPassword';
import ThemeContextProvider from 'contexts/theme_context/ThemeContext';
import LanguageContextProvider from 'contexts/language_context/LanguageContext';
import Tables from 'pages/tables/Tables';
import NotFound from 'pages/not_found/NotFound';
import Maintenance from 'pages/maintenance_page/Maintenance';
import SingleVehicle from 'pages/single_vehicle/SingleVehicle';
import AuthContextProvider from 'contexts/auth_context/AuthContext';
import ComplaintForm from 'pages/complaint_form/ComplaintForm';
import ComplaintFormDemo from 'components/complaint_form/ComplaintFormDemo';
import VehicleContextProvider from 'contexts/vehicles_context/VehiclesContext';
import React, { useEffect } from 'react';
import ShiftLens from 'pages/shiftlens/ShiftLens';
import ChoicePage from 'pages/choice_page/ChoicePage';
import ProtectedRoute from 'components/auth/ProtectedRoute';
import CustomerPortal from 'pages/customer_portal/CustomerPortal';

import WeeklyDemandPlanner from 'pages/weekly_demand/WeeklyDemandPlanner';

export const isPublicSignupEnabled = () => process.env.REACT_APP_ENABLE_PUBLIC_SIGNUP === 'true';

function App() {
  const clearCacheData = () => {
    if (typeof window === 'undefined' || !window.caches) return;

    window.caches.keys().then((names) => {
      names.forEach((name) => {
        window.caches.delete(name);
      });
    }).catch(() => {});
  };

  useEffect(() => {
    clearCacheData();
  }, []);

  let myRoutes = createBrowserRouter([
    {
      path: '/',
      element: <Master />,
      children: [
        { path: '/', element: <ProtectedRoute><Navigate to='/customer-portal/operating-analysis' replace /></ProtectedRoute> },
        { path: '/choice', element: <ProtectedRoute><ChoicePage /></ProtectedRoute> },
        { path: '/login', element: <Login /> },
        {
          path: '/signup',
          element: isPublicSignupEnabled() ? <Signup /> : <Navigate to='/login' replace />
        },
        { path: '/reset/password', element: <ResetPassword /> },
        {
          path: '/table/:type',
          element: <ProtectedRoute><Tables /></ProtectedRoute>
        },
        { path: '/maintenance', element: <Maintenance /> },
        {
          path: '/shiftlens',
          element: <ProtectedRoute><ShiftLens /></ProtectedRoute>
        },
        {
          path: '/customer-portal',
          element: <ProtectedRoute><Navigate to='/customer-portal/operating-analysis' replace /></ProtectedRoute>
        },
        {
          path: '/customer-portal/:section',
          element: <ProtectedRoute><CustomerPortal /></ProtectedRoute>
        },
        {
          path: '/complaint-form-demo',
          element: <ProtectedRoute><ComplaintFormDemo /></ProtectedRoute>
        },
        {
          path: '/single/vehicle/:id',
          element: <ProtectedRoute><SingleVehicle /></ProtectedRoute>
        },
        {
          path: '/complaint/:id/:mileage',
          element: <ProtectedRoute><ComplaintForm /></ProtectedRoute>
        },
        {
          path: '/add/new_password/:uid/:token/:moretoken',
          element: <NewPassword />
        },

        {
          path: '/mrp/weekly-demand',
          element: <ProtectedRoute><WeeklyDemandPlanner /></ProtectedRoute>
        },

        { path: '*', element: <NotFound /> },
      ],
    },
  ]);

  return (
    <AuthContextProvider>
      <VehicleContextProvider>
        <LanguageContextProvider>
          <ThemeContextProvider>
            <RouterProvider router={myRoutes}></RouterProvider>
          </ThemeContextProvider>
        </LanguageContextProvider>
      </VehicleContextProvider>
    </AuthContextProvider>
  );
}

export default App;
